import React, { JSX } from 'react'

const CloseIcon: React.FC<JSX.IntrinsicElements['svg']> = (props) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M27 1L1 27"
      stroke="#1C1C1C"
      strokeWidth="1.85714"
      strokeMiterlimit="10"
    />
    <path
      d="M1 1L27 27"
      stroke="#1C1C1C"
      strokeWidth="1.85714"
      strokeMiterlimit="10"
    />
  </svg>
)

export default CloseIcon
